import useIsAskActive from '@/hooks/useIsAskActive';
import { useAppSelector } from '@/utils/redux';

/**
 * Whether Ask AllTrails takes over the sidebar, map pins and filter pills. Ask should stay on as the user
 * moves between pages.
 */
const useIsAskShowing = () => {
  const isAskActive = useIsAskActive();
  const isAskAvailable: boolean = useAppSelector(state => state.ask.isAvailable);

  return isAskActive && isAskAvailable;
};

export default useIsAskShowing;
